import { z } from "zod";

export const insuranceCardImageSideSchema = z.object({
  side: z.enum(["front", "back", "unspecified"]),
  mediaType: z.string().min(1),
  contentBase64: z.string().min(1),
});

export const insuranceCardFieldSchema = z.object({
  label: z.string().min(1),
  value: z.string().min(1),
});

export const insuranceCardViewSchema = z.discriminatedUnion("kind", [
  z.object({
    kind: z.literal("images"),
    source: z.enum(["payer", "ehr"]),
    sides: z.array(insuranceCardImageSideSchema).min(1),
  }),
  z.object({
    kind: z.literal("synthetic"),
    source: z.literal("eligibility"),
    front: z.array(insuranceCardFieldSchema),
    back: z.array(insuranceCardFieldSchema),
  }),
]);

export const insuranceCardResponseSchema = z.object({
  card: insuranceCardViewSchema.nullable(),
});

export type InsuranceCardImageSide = z.infer<typeof insuranceCardImageSideSchema>;
export type InsuranceCardField = z.infer<typeof insuranceCardFieldSchema>;
export type InsuranceCardView = z.infer<typeof insuranceCardViewSchema>;
export type InsuranceCardResponse = z.infer<typeof insuranceCardResponseSchema>;
